import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import Menu from "@mui/material/Menu";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";
import { studyService } from "../services/study.service";
import cardImg from "../assets/images/studyCardImg.png";

const StudyingMenu = ({ anchorEl, handleClose, open }: any) => {
  const [study, setStudy] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    studyService.getStudy("limit=4").then((data) => setStudy(data.data.items));
  }, []);

  const courseClicked = (el: any) => {
    console.log("el", el);
    navigate(`/course/learn/${el.course_id}/${el.id}`);
  };

  const EmptyStudy = () => {
    return (
      <Box>
        <Box className={"study-menu-empty-title"}>
          У вас пока нет купленных курсов
        </Box>
        <Box className={"study-menu-empty-subtitle"}>
          Приобретите заинтересовавший вас курс
        </Box>
      </Box>
    );
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          border: "1px solid rgba(1, 18, 36, 0.08)",
          boxShadow: "6px -3px 12px 0px rgba(0, 0, 0, 0.05)",
          width: "448px",
          borderRadius: "8px",
          padding: "8px 16px",
          li: {
            fontSize: "14px",
            fontWeight: 800,
            padding: "12px 16px",
          },
          ".lang": {
            fontSize: "12px",
            fontWeight: 600,
            color: "rgba(128, 137, 146, 1)",
          },

          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          "&::before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
      {study.length ? (
        <Box>
          {study.map((el: any) => {
            return (
              <Box key={el.id} onClick={() => courseClicked(el)}>
                <Card
                  sx={{
                    display: "flex",
                    margin: "12px 0",
                    boxShadow: "none",
                    cursor: "pointer",
                    "&:hover": {
                      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    },
                  }}>
                  <CardMedia
                    component="img"
                    sx={{ width: 148, borderRadius: "8px", height: 84 }}
                    image={cardImg}
                    alt="Live from space album cover"
                  />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}>
                    <CardContent sx={{ flex: "1 0 auto", padding: "0 12px" }}>
                      <Box className={"card-course-menu-title"}>{el.name}</Box>
                      <Box
                        className={"card-course-progress-bar"}
                        sx={{ marginTop: "12px" }}>
                        <Box
                          className={"card-course-bar"}
                          sx={{ width: `${el.covered_material}%` }}
                        />
                      </Box>
                      <Box className={"card-course-progress-title"}>
                        {el.covered_material === 0
                          ? "Не начато"
                          : `Завершено на ${el.covered_material}%`}
                      </Box>
                    </CardContent>
                  </Box>
                </Card>
              </Box>
            );
          })}
          <Divider />
        </Box>
      ) : (
        <EmptyStudy />
      )}

      <Box
        sx={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          marginTop: "12px",
        }}>
        {" "}
        <Button
          variant="outlined"
          className="header-controls"
          sx={{ height: "44px" }}
          onClick={() => navigate("/studying")}>
          Перейти в мое обучение
        </Button>
      </Box>
    </Menu>
  );
};

export default StudyingMenu;
